const cardItems = [
  {
    title: '如何挑选适合你的4K播放设备？',
    desc: '从电视到投影仪，高清电影在线观看的最佳硬件搭配指南，让你的蓝光影视资源体验再升级。',
    date: '2026-07-28',
    tag: '观影指南',
    img: 'https://readdy.ai/api/search-image?query=Modern%20home%20theater%20setup%20with%20large%20TV%20screen%20and%20comfortable%20sofa%20in%20dim%20ambient%20lighting%2C%20cozy%20cinema%20room%20atmosphere%2C%20warm%20golden%20accent%20lights%2C%20clean%20minimalist%20interior&width=600&height=400&seq=cards-01-device&orientation=landscape',
  },
  {
    title: '2026年最值得期待的10部续集电影',
    desc: '经典IP纷纷回归，高清影视大全抢先盘点明年必看的重磅续作，你的钱包准备好了吗？',
    date: '2026-07-25',
    tag: '前瞻盘点',
    img: 'https://readdy.ai/api/search-image?query=Cinematic%20movie%20countdown%20with%20dramatic%20spotlight%20on%20film%20clapperboard%2C%20Hollywood%20blockbuster%20aesthetic%2C%20dark%20theater%20background%20with%20golden%20highlights%2C%20anticipation%20and%20excitement%20mood&width=600&height=400&seq=cards-02-sequel&orientation=landscape',
  },
  {
    title: '蓝光 vs 流媒体：画质差异到底有多大？',
    desc: '专业对比蓝光影视资源与在线高清播放的画质区别，告诉你为什么真正的影迷选择蓝光。',
    date: '2026-07-20',
    tag: '技术科普',
    img: 'https://readdy.ai/api/search-image?query=Close-up%20of%20blu-ray%20disc%20with%20iridescent%20reflection%20alongside%20modern%20streaming%20device%2C%20tech%20comparison%20concept%2C%20clean%20studio%20lighting%2C%20product%20photography%20style%20with%20cool%20and%20warm%20color%20contrast&width=600&height=400&seq=cards-03-bluray&orientation=landscape',
  },
  {
    title: '周末片单：5部让你笑到停不下来的喜剧',
    desc: '高清电视剧免费频道精选爆笑内容，从国产喜剧到好莱坞经典，拯救不开心。',
    date: '2026-07-18',
    tag: '片单推荐',
    img: 'https://readdy.ai/api/search-image?query=Vibrant%20colorful%20popcorn%20and%20film%20reels%20on%20bright%20yellow%20background%2C%20fun%20and%20energetic%20movie%20night%20concept%2C%20playful%20cinematography%20lighting%2C%20joyful%20and%20lively%20atmosphere&width=600&height=400&seq=cards-04-comedy&orientation=landscape',
  },
  {
    title: '影迷必知的5个观影冷知识',
    desc: '关于超清综艺播放和高清电影在线观看的有趣知识，让你在朋友面前秒变影评达人。',
    date: '2026-07-15',
    tag: '趣味知识',
    img: 'https://readdy.ai/api/search-image?query=Vintage%20film%20projector%20with%20warm%20glowing%20light%20beam%20in%20dark%20room%2C%20nostalgic%20cinema%20atmosphere%2C%20old%20Hollywood%20charm%2C%20dust%20particles%20floating%20in%20light%20beam%2C%20classic%20movie%20aesthetic&width=600&height=400&seq=cards-05-trivia&orientation=landscape',
  },
];

export default function Cards() {
  return (
    <section id="cards" className="py-12 md:py-16 bg-background-100">
      <div className="section-container">
        <h2 className="font-display text-2xl md:text-3xl text-foreground-950 text-center mb-2">影视资讯</h2>
        <p className="text-sm text-foreground-500 text-center mb-8 md:mb-10">最新影视资讯、观影指南与深度内容</p>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-5">
          {cardItems.map((item, i) => (
            <a
              key={i}
              href="#cards"
              onClick={(e) => e.preventDefault()}
              className="bg-background-50 rounded-lg overflow-hidden cursor-pointer group"
            >
              <div className="relative aspect-[3/2] overflow-hidden">
                <img
                  src={item.img}
                  alt={item.title}
                  className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105"
                />
                <div className="absolute top-3 left-3">
                  <span className="inline-flex items-center px-2 py-0.5 rounded-full text-[10px] font-medium bg-accent-100 text-accent-800 whitespace-nowrap">
                    {item.tag}
                  </span>
                </div>
              </div>
              <div className="p-4">
                <div className="flex items-center gap-2 text-[10px] text-foreground-400 mb-2">
                  <i className="ri-calendar-line"></i>
                  <span>{item.date}</span>
                </div>
                <h3 className="text-sm md:text-base font-semibold text-foreground-900 mb-1.5 line-clamp-2">{item.title}</h3>
                <p className="text-xs text-foreground-500 leading-relaxed line-clamp-2">{item.desc}</p>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}